import React from 'react';
import { Select } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Option } = Select;

interface LanguageSwitcherProps {
  className?: string;
  size?: 'small' | 'middle' | 'large';
  showIcon?: boolean;
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ 
  className, 
  size = 'middle',
  showIcon = true 
}) => {
  const { i18n, t } = useTranslation();

  const handleLanguageChange = (language: string) => {
    i18n.changeLanguage(language);
    localStorage.setItem('i18nextLng', language);
  };

  const languages = [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'ja', name: '日本語', flag: '🇯🇵' },
  ];

  const getCurrentLanguageFlag = () => {
    const currentLang = languages.find(lang => lang.code === i18n.language);
    return currentLang?.flag || '🌐';
  };

  return (
    <Select
      value={i18n.language}
      onChange={handleLanguageChange}
      className={className}
      size={size}
      style={{ minWidth: 120 }}
      suffixIcon={showIcon ? <GlobalOutlined /> : null}
      aria-label={t('common.language')}
    >
      {languages.map((language) => (
        <Option key={language.code} value={language.code}>
          <span style={{ marginRight: 8 }}>{language.flag}</span>
          {language.name}
        </Option>
      ))}
    </Select>
  );
};

export default LanguageSwitcher;
